import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { B04User } from '../interfaces/b04-user';

export const b04UserEvents = eventGroup({
  source: 'B04User',
  events: {
    syncUserSuccess: type<{ user: B04User }>(),
    syncUserFailure: type<void>(),
  },
});
